import * as React from 'react';
import { Input, message } from "antd";
import { SendOutlined } from "@ant-design/icons";
import scrollIntoView from "scroll-into-view-if-needed";
const Chat = require("twilio-chat");
import "./Styles/Chat.scss";
import Loader from './Loader';
import dayjs from 'dayjs';
import utils from 'utils';
import { connect } from "react-redux";
import consultationSlice from 'store/slice/consultation-slice';
class ChatComponent extends React.Component {

    client = null;
    constructor(props) {
        super(props);
        this.state = {
            createdBy:"", patient_friendly_name:"", care_admin_friendly_name:"",
            text: "",
            messages: [],
            channel: null,
            roomName: "",
            token: "",
            isLoading: true,
            user: this.props.user || {},
            isChannelRemoved: true,
            user_details: this.props.user_details,
            chat_data: this.props.user_details.role == "patient" ? this.props?.chat_data : Object.assign({}, this.props.chat_data.results[0])
        }
    }

    addMessages = (message) => {
        const { messages } = this.state;
        let msg = Array.isArray(message) && message.length ? message : (!Array.isArray(message) && typeof message == "object" ? [message] : []);
        this.setState({
            messages: [...messages, ...msg],
        }, () => {
            if (document.getElementById(`message-list-item-${this.state.messages?.length - 1}`)) {
                scrollIntoView(document.getElementById(`message-list-item-${this.state.messages?.length - 1}`), {
                    behavior: "instant",
                    scrollMode: "if-needed",
                    boundary: document.getElementById("message-container"),
                });
                // this.setState({
                //     isMemberJoined: true
                // });
            }

        });
    };

    sendMessage = () => {

        const { strValue, channel } = this.state;

        if (strValue && String(strValue).trim()) {
            channel && channel.sendMessage(strValue);
            this.setState({ strValue: "" });
        }
    };


    joinChannel = async (channel) => {
        if (channel.channelState.status !== "joined") {
            await channel.join();
        }
        this.setState({
            channel,
            // isLoading: false
        });
        this.handleChannelEvents(channel);
    };

    handleChannelEvents(channel) {
        channel.on("messageAdded", this.addMessages);
        channel.on("memberJoined", () => {
            this.setState({
                isMemberJoined: true,
                isChannelRemoved: false
            })
        });
        channel.on('channelRemoved', channel => {
            this.setState({
                isChannelRemoved: true
            })
            typeof this.props.onCloseChannel == "function" && this.props.onCloseChannel();
        });
        channel.on('channelUpdated', channel => {
            this.setState({
                isChannelRemoved: true
            })
            typeof this.props.onCloseChannel == "function" && this.props.onCloseChannel();
        });
    }

    // handleChatEvents(client) {
    //     client.on("memberLeft", (state) => {
    //         console.log(state)
    //     });
    //     client.on("typingEnded", (state) => {
    //         console.log(state)
    //     });
    //     client.on("typingStarted", (state) => {
    //         console.log(state)
    //     });


    // }

    // createChatChannel = async () => {
    //     // console.log(this.state.chat_data,)
    //     // console.log(this.state.chat_data?.patient_token || Object.assign({}, this.props.chat_data.results[0]))

    //     const client = await Chat.Client.create(this.state.chat_data?.patient_token || this.state.chat_data?.care_admin_token);
    //     // console.log(client)
    //     client.on("channelJoined", async (channel) => {


    //         const { uniqueName, friendlyName, createdBy } = channel.channelState || {}

    //         if ((this.state.chat_data.room_id) === uniqueName) {
    //             const messages = await channel.getMessages();

    //             // console.log("Messages",messages)
    //             let { items: old_messages } = messages || {}

    //             //messages?.items?.length == 0 && channel.sendMessage(`Hi ${createdBy == this.state.user?.user_id && utils.FormatName(friendlyName) || "there"}How can we help you todya?`);
    //             if (this.state.user?.role == "care-admin"){
    //                 // old_messages.push(`Hi ${this.state?.user.name} ,You are connected with ${createdBy != this.state.user?.user_id && utils.FormatName(friendlyName) || "there"}!`)
    //                 // console.log("old messages", old_messages[0].body);
    //                 // this.setState(state => ({messages:[ { state: { body: `Hi ${this.state?.user.name} ,You are connected with ${createdBy != this.state.user?.user_id && utils.FormatName(friendlyName) || "there"}!` } }]}))    
    //                 this.setState(state => ({
    //                     messages: [...state.messages, old_messages.length > 0 ? {
    //                         state: messages.items.map((t) => {
    //                             return ({ author: t.author, body: t.body })
    //                         })
    //                     } :
    //                      { state: { author: -1, body: `Hi ${this.state?.user.name} ,You are connected with ${createdBy != this.state.user?.user_id && utils.FormatName(friendlyName) || "there"}!` } }
    //                     ]
    //                 }))
    //             }
    //             if (this.state.user?.role == "patient") {

    //                 this.setState(state => ({
    //                     messages: [...state.messages, { state: { body: `Hi ${this.state.user?.name || "there"}! How can we help you today?` } }]
    //                 }))


    //             }
    //         }
    //     });
    //     try {
    //         const channel = await client.getChannelByUniqueName(this.state?.chat_data?.room_id);

    //         await this.joinChannel(channel);

    //     } catch (err) {
    //         try {

    //             const channel = await client.createChannel({
    //                 uniqueName: this.state?.chat_data?.room_id,
    //                 friendlyName: this.state.user?.name,
    //             });
    //             await this.joinChannel(channel);
    //         } catch (err) {
    //             throw new Error("unable to create channel, please reload this page", err);
    //         }
    //     }
    // }

    createChatChannel = async () => {
        // console.log(this.state.chat_data,        
        // console.log(this.state.chat_data?.patient_token || Object.assign({}, this.props.chat_data.results[0]))                             
        // const client = await Chat.Client.create(this.state.chat_data?.patient_token || this.state.chat_data?.care_admin_token);
        const client = await Chat.Client.create(this.props.token || this.props.care_token);
        client.on("channelJoined", async (channel) => {
            const { uniqueName, friendlyName, createdBy } = channel.channelState || {}
            // console.log(this.state.chat_data.room_id , uniqueName)                      

            // if ((this.state.chat_data.room_id) === uniqueName) {
            if ((this.props.room_id) === uniqueName) {
                this.setState({ createdBy: createdBy, patient_friendly_name: friendlyName })
                const messages = await channel.getMessages();
                let { items: old_messages } = messages || {}
                if (this.state.user?.role == "care-admin") {
                    this.displayWaitingMsg();
                    // console.log("old", old_messages)
                    if (old_messages.length > 0) {
                        this.setState(state => ({
                            messages: [...state.messages, {
                                state: messages.items.map((t) => {
                                    return ({ author: t.author, body: t.body })
                                })
                            }]
                        }))
                    }
                }
                if (this.state.user?.role == "patient") {
                    this.displayWaitingMsg();
                    // console.log("oldPatient", old_messages)
                    if (old_messages.length > 0) {
                        this.setState(state => ({
                            messages: [...state.messages, {
                                state: messages.items.map((t) => {
                                    return ({ author: t.author, body: t.body })
                                })
                            }]
                        }))
                    }
                }
            }
        });
        // client.on("tokenAboutToExpire", async () => {
        //       message.warning('3 minutes left in your scheduled meeting time.', 10);
        //   });
        try {
            const channel = await client.getChannelByUniqueName(this.props.room_id);
            // const channel = await client.getChannelByUniqueName(this.state?.chat_data?.room_id);
            await this.joinChannel(channel);
        } catch (err) {
            try {
                const channel = await client.createChannel({
                    uniqueName: this.props.room_id,
                    // uniqueName: this.state?.chat_data?.room_id,
                    friendlyName: this.state.user?.name,
                });
                await this.joinChannel(channel);
            } catch (err) {
                throw new Error("unable to create channel, please reload this page", err);
            }
        }
    }

        
        
        
    displayWaitingMsg() {
        let count = 1, flag = false;
        let timer = setInterval(() => {
            const { channel } = this.state;
            // if (this.state.isMemberJoined) {
            //     const { uniqueName, friendlyName, createdBy } = channel.channelState || {}
            //     channel.sendMessage(`Hi ${createdBy != this.state.user_id && utils.FormatName(friendlyName) || "there"}! How can we help you today?`)
            //     clearInterval(timer);
            //     return 0;
            // }
            // if (!this.state.isMemberJoined && count % 60 == 0 && this.state.messages?.length < 4) {       
            //     this.setState(state => ({       
            //         messages: [...state.messages, { state: { body: `All of our support team members are ${flag ? "still " : ""}busy. Please hold on or try again after sometime.` } }]   
            //     }))      
            //     flag = true;   
            // }     
            // count++
        }, 1000);
        if (this.state?.channel?.channelState?.status == "joined" && this.props.user_details.role == "care-admin") {
            this.setState(state => ({
                messages: [...state.messages, { state: { body: `Hi ${this.props?.user_details?.name} ,You are connected with ${this.state.createdBy != this.props.user_details?.user_id && this.state.patient_friendly_name || "there"}!` } }]
            }))
        }
        if (this.state?.channel?.channelState?.status == "joined" && this.props.user_details.role == "patient") {
            this.setState(state => ({
                messages: [...state.messages, { state: { body: `Hi ${this.props?.user_details?.name || "there"}! How can we help you today?` } }]
            }))
        }
        this.setState({ isLoading: false})
    }

    

    // displayWaitingMsg() {
    //     let count = 1, flag = false;

    //     let timer = setInterval(() => {
    //         const { channel } = this.state;
    //         if (this.state.isMemberJoined) {
    //             const { uniqueName, friendlyName, createdBy } = channel.channelState || {}
    //             // console.log(channel)
    //             channel.sendMessage(`Hi ${createdBy != this.state.user?.user_id && utils.FormatName(friendlyName) || "there"}! How can we help you today?`)
    //             clearInterval(timer);
    //             return 0;
    //         }
    //         // if (!this.state.isMemberJoined && count % 60 == 0 && this.state.messages?.length < 4) {
    //         //     this.setState(state => ({
    //         //         messages: [...state.messages, { state: { body: `All of our support team members are ${flag ? "still " : ""}busy. Please hold on or try again after sometime.` } }]
    //         //     }))
    //         //     flag = true;
    //         // }
    //         // count++
    //     }, 1000);
    //     if(this.state?.channel?.channelState?.status=="joined" && this.props.user_details.role=="care-admin"){ this.setState(state => ({ messages: [...state.messages, { state: { body: `Hi ${this.props?.user_details?.name} ,You are connected with ${this.state.createdBy != this.props.user_details?.user_id && this.state.patient_friendly_name || "there"}!` } }] })) }
    // }

    closeChannel() {
        let timer = setInterval(() => {
            const { channel } = this.state;
            const { dateCreated } = channel?.channelState?.lastMessage || {};
            if (dateCreated && dayjs().isAfter(dayjs(dateCreated).add(15, "minutes"))) {
                this.state.channel.delete().then(channel => {
                    typeof this.props.onCloseChannel == "function" && this.props.onCloseChannel();
                });
                clearInterval(timer);
            };
        }, 1000);
    }
    componentDidMount = () => {
        this.setState({user_id:this.props.identity})
        this.createChatChannel();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state != nextState) return true;
        else if (nextProps.room_id == this.props.room_id) return false;
        return true;
    }

    renderFooter() {
        // if(this.state.isChannelRemoved && this.state.user?.role == "care-admin" && !this.state.isMemberJoined) {
        //     return <div className='waiting-message'>You are not allowed to send messages in this chat. Wait for the user to join.</div>
        // console.log(this.state.user.role, this.state.channel)
        // }
        if (this.state?.user?.role == "patient") {
            return <Input.Group compact>
                <Input
                    className="send-message-icon"
                    addonAfter={<SendOutlined onClick={this.sendMessage} className="send-message-icon" />}
                    placeholder="Type a new message"
                    value={this.state.strValue || null}
                    onChange={(event) =>
                        this.setState({ strValue: event.target.value })
                    }

                    onPressEnter={this.sendMessage}
                />
            </Input.Group>
        } else if (this.state.user?.role == "care-admin") {
            return <Input.Group compact>
                <Input
                    className="send-message-icon"
                    addonAfter={<SendOutlined onClick={this.sendMessage} className="send-message-icon" />}
                    placeholder="Type a new message"
                    value={this.state.strValue || null}
                    onChange={(event) =>
                        this.setState({ strValue: event.target.value })
                    }

                    onPressEnter={this.sendMessage}
                />
            </Input.Group>
        }
        return null
    }

    render() {
        const { showHeader, style } = this.props
        // console.log("objects",Object.assign({}, this.props.chat_data.results))
        // console.log("chatObjects", this.props.chat_data)
        return (
            <>
             {this.state.isLoading ? <Loader /> :  <div className='chat-container'>
                <div className='chat-wrapper'>
                    <div className={`chat-header ${showHeader == false ? " hide" : " show"}`}>Chat</div>
                    <div className="message-container" id="message-container" style={style || {}}>

                        {this.state.messages.map((obj, i) => {
                            let { state: message } = obj || {};

                            return (
                                message.length > 0 && this.state.user_details.role == "care-admin" ?
                                    Object.values(message).map((t) => {
                                        return (
                                            <div
                                                key={i}
                                                id={`message-list-item-${i}`}
                                                className={t?.author == this.state.user?.user_id?.toString() ? "local-user" : "remote-user"}
                                            >
                                                {/* <div className={message.author != this.state.user?.user_id && message.author == this.state.messages[i - 1]?.author ? "remove-avatar" : ""}>
                                        {message.author != this.state.user?.user_id && message.author != this.state.messages[i - 1]?.author ? <div className="profile-avatar">
                                            {message.user_name?.[0] || "U"}
                                        </div> : null}
                                    </div> */}
                                                <div className="user-message"><span>{t?.body}</span></div>

                                            </div>
                                        )
                                    }) 
                                    :
                                    // < div
                                    //     key={i}
                                    //     id={`message-list-item-${i}`
                                    //     }
                                    //     className={message?.author == this.state.user?.user_id?.toString() ? "local-user" : "remote-user"}
                                    // >

                                    //     <div className="user-message"><span>{message?.body}</span></div>
                                    // </div>
                                    ( message.length > 0 && this.state.user_details.role == "patient" ? 
                                    Object.values(message).map((t) => {
                                        return (
                                            <div
                                                key={i}
                                                id={`message-list-item-${i}`}
                                                className={t?.author == this.state.user?.user_id?.toString() ? "local-user" : "remote-user"}
                                            >
                                                {/* <div className={message.author != this.state.user?.user_id && message.author == this.state.messages[i - 1]?.author ? "remove-avatar" : ""}>
                                        {message.author != this.state.user?.user_id && message.author != this.state.messages[i - 1]?.author ? <div className="profile-avatar">
                                            {message.user_name?.[0] || "U"}
                                        </div> : null}
                                    </div> */}
                                                <div className="user-message"><span>{t?.body}</span></div>
                                            </div>
                                        )
                                    })                                    
                                    :< div 
                                        key={i}
                                        id={`message-list-item-${i}`
                                        }
                                        className={message?.author == this.state.user?.user_id?.toString() ? "local-user" : "remote-user"}
                                    >

                                        <div className="user-message"><span>{message?.body}</span></div>
                                    </div>
                                    )
                                   

                            )
                        })}
                    </div>
                    <div className='chat-footer'>
                        { this.renderFooter()}
                    </div>
                </div>
            </div >}
            </>
            );
    }

}

const mapStateToProps = (state) => {
    return {
        user_details: state.loginReducer.user_details,
        chat_data: state.careAdminReducer.chat_data,
    };
};
export default connect(mapStateToProps)(ChatComponent);